import useCookiesAccepted from '@hooks/useCookiesAccepted'
import useEffect from '@hooks/useEffect'
import getEnv from '@providers/getEnv'
import LogRocket from 'logrocket'

const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const isSelected = () => {
  // Is a random that only would be true on 0,04% of all sessions
  return random(1, 250000) <= 100
}

export default function useLogRocket() {
  const cookies = useCookiesAccepted()
  useEffect(() => {
    if (getEnv() !== 'prod' || !isSelected() || !cookies) return
    LogRocket.init('1raysq/justo')
  }, [cookies])
}

export const WithLogRocket = ({children}) => {
  useLogRocket()
  return children
}
